import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { format } from 'date-fns'
import { Input } from './FormDatepicker.style'

// eslint-disable-next-line react/prefer-stateless-function
class FormDatePickerInput extends Component {
  render() {
    const { onClick, date, hasError, isDisabled } = this.props
    const formattedDate = format(date, 'DD/MM/YYYY')

    return (
      <Input
        as="input"
        onClick={onClick}
        value={formattedDate}
        hasError={hasError}
        isDisabled={isDisabled}
        readOnly
      />
    )
  }
}

FormDatePickerInput.propTypes = {
  onClick: PropTypes.func,
  date: PropTypes.instanceOf(Date).isRequired,
  hasError: PropTypes.bool,
  isDisabled: PropTypes.bool,
}

FormDatePickerInput.defaultProps = {
  onClick: null,
  hasError: false,
  isDisabled: false,
}

export default FormDatePickerInput
